import "./Logo.css";

const Logo = () => {
  return <div className="logo">LOGO</div>;
};

export default Logo;
